// import axiosInstance from "./Axiosinstance";

// const doctorService = {
//   login: async (payload) => {
//     try {
//       const response = await axiosInstance.post("/login", payload);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data;
//     }
//   },

//   getProfile: async (id) => {
//     try {
//       const response = await axiosInstance.get(`/me/${id}`);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data;
//     }
//   },

//   getTodayPatients: async (id) => {
//     try {
//       const response = await axiosInstance.get(`/patients/today/${id}`);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data;
//     }
//   },

//   getAllPatients: async (id) => {
//     try {
//       const response = await axiosInstance.get(`/patients/all/${id}`);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data;
//     }
//   },

//   getPatientDetail: async (sale_id, doctor_id) => {
//     try {
//       const response = await axiosInstance.get(`/patient/${sale_id}/${doctor_id}`);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data;
//     }
//   },

//   savePrescription: async (payload) => {
//     try {
//       const response = await axiosInstance.post("/prescriptions", payload);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data;
//     }
//   },

//   getPrescription: async (sale_id) => {
//     try {
//       const response = await axiosInstance.get(`/prescriptions/${sale_id}`);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data;
//     }
//   },

//   getDuties: async (id) => {
//     try {
//       const response = await axiosInstance.get(`/duties/${id}`);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data;
//     }
//   },

//   getTodayDuty: async (id) => {
//     try {
//       const response = await axiosInstance.get(`/duties/today/${id}`);
//       return response.data;
//     } catch (error) {
//       throw error.response?.data;
//     }
//   },
// };

// export default doctorService;

import axiosInstance from "./Axiosinstance";

const doctorService = {
  login: async (payload) => {
    try {
      const response = await axiosInstance.post("/doctor-portal/login", payload);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getProfile: async (id) => {
    try {
      const response = await axiosInstance.get(`/doctor-portal/me/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getTodayPatients: async (id) => {
    try {
      const response = await axiosInstance.get(`/doctor-portal/patients/today/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getAllPatients: async (id) => {
    try {
      const response = await axiosInstance.get(`/doctor-portal/patients/all/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getPatientDetail: async (sale_id, doctor_id) => {
    try {
      const response = await axiosInstance.get(`/doctor-portal/patient/${sale_id}/${doctor_id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  savePrescription: async (payload) => {
    try {
      const response = await axiosInstance.post("/doctor-portal/prescriptions", payload);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getPrescription: async (sale_id) => {
    try {
      const response = await axiosInstance.get(`/doctor-portal/prescriptions/${sale_id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getLabTests: async () => {
    try {
      const response = await axiosInstance.get("/lab-catalog/tests");
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getRadiologyExams: async () => {
    try {
      const response = await axiosInstance.get("/rad-catalog/exams", { params: { status: "Active" } });
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getDuties: async (id) => {
    try {
      const response = await axiosInstance.get(`/doctor-portal/duties/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getTodayDuty: async (id) => {
    try {
      const response = await axiosInstance.get(`/doctor-portal/duties/today/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },
};

export default doctorService;